declare global {
	interface Window {
		grecaptcha?: {
			ready: (cb: () => void) => void;
			execute: (captchaKey: string, opts: { action: 'submit' }) => Promise<string | undefined>;
		};
	}
}

function resolveSiteKey(siteKey?: string): string | undefined {
	return siteKey ?? import.meta.env.VITE_GOOGLE_RECAPTCHA_SITE_KEY;
}

/** @deprecated Use `generateCaptchaTokenResult` instead, as it provides a result with error handling */
export function generateCaptchaToken(siteKey?: string): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		if (window.grecaptcha) {
			window.grecaptcha.ready(function () {
				const key = resolveSiteKey(siteKey);
				if (key !== undefined) {
					window.grecaptcha?.execute(key, { action: 'submit' }).then((captchaToken) => {
						if (captchaToken) {
							resolve(captchaToken);
						} else {
							reject(new Error('[WARN] Failed to generate captcha token'));
						}
					});
				} else {
					reject(new Error('[WARN] Invalid Google Recaptcha site key or invalid origin'));
				}
			});
		} else {
			reject(new Error('[WARN] Google Recaptcha not loaded'));
		}
	});
}

type GenerateCaptchaTokenResult =
	| { data: string; error: null }
	| { data: null; error: 'INVALID_CAPTCHA' | 'CAPTCHA_NOT_LOADED' | 'INVALID_CAPTCHA_KEY_OR_ORIGIN' };

export function generateCaptchaTokenResult(siteKey?: string): Promise<GenerateCaptchaTokenResult> {
	return new Promise<GenerateCaptchaTokenResult>((resolve) => {
		if (window.grecaptcha) {
			window.grecaptcha.ready(function () {
				const key = resolveSiteKey(siteKey);
				if (key !== undefined) {
					window.grecaptcha?.execute(key, { action: 'submit' }).then((captchaToken) => {
						if (captchaToken) {
							resolve({ data: captchaToken, error: null });
						} else {
							resolve({ data: null, error: 'INVALID_CAPTCHA' });
						}
					});
				} else {
					resolve({ data: null, error: 'INVALID_CAPTCHA_KEY_OR_ORIGIN' });
				}
			});
		} else {
			resolve({ data: null, error: 'CAPTCHA_NOT_LOADED' });
		}
	});
}
